// extracted by mini-css-extract-plugin
export default {"closeButton":"TM6znx","page":"nb7lGW","title":"WD81sR","description":"AZOuwY","loginButtonContainer":"qdoEtQ"};